import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';

export interface ValidVehicles {
  img: string;
  header: string;
  text: string;
  maxWidth?: string;
  maxHeight?: string;
}

@Component({
  selector: 'app-valid-vehicles',
  templateUrl: './valid-vehicles.component.html',
  styleUrls: ['./valid-vehicles.component.scss'],
})
export class ValidVehiclesComponent {
  validVehicles: ValidVehicles[];

  onPath(path: string): boolean {
    return this.router.url.split('?')[0].split('#')[0] === path;
  }

  constructor(
    private transloco: TranslocoService,
    private router: Router,
  ) {
    this.validVehicles = [
      {
        img: 'assets/images/valid-vehicles/3.png',
        header: this.transloco.translate('home.validVehicles.slide.1.header'),
        text: this.transloco.translate('home.validVehicles.slide.1.text'),
      },
      {
        img: 'assets/images/valid-vehicles/2.png',
        header: this.transloco.translate('home.validVehicles.slide.2.header'),
        text: this.transloco.translate('home.validVehicles.slide.2.text'),
      },
      {
        img: 'assets/images/ikona_taxi.png',
        header: this.transloco.translate('home.validVehicles.slide.3.header'),
        text: this.transloco.translate('home.validVehicles.slide.3.text'),
        maxWidth: '120px',
        maxHeight: '120px',
      },
      {
        img: 'assets/images/valid-vehicles/7.png',
        header: this.transloco.translate('home.validVehicles.slide.4.header'),
        text: this.transloco.translate('home.validVehicles.slide.4.text'),
      },
      {
        img: 'assets/images/valid-vehicles/6.png',
        header: this.transloco.translate('home.validVehicles.slide.5.header'),
        text: this.transloco.translate('home.validVehicles.slide.5.text'),
      },
    ];
  }
}
